import { render, staticRenderFns } from "./EmployeesBlock.vue?vue&type=template&id=8bec383e"
import script from "./EmployeesBlock.vue?vue&type=script&lang=js"
export * from "./EmployeesBlock.vue?vue&type=script&lang=js"
import style0 from "./EmployeesBlock.vue?vue&type=style&index=0&id=8bec383e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports